'use strict';

var $$Array = require("bs-platform/lib/js/array.js");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Codons$Genetics = require("./Codons.bs.js");

function formatRaw3Code(text) {
  return $$Array.fold_left((function (acc, x) {
                return $$Array.append(x, acc);
              }), [], $$Array.map((function (x) {
                      return $$Array.map((function (x) {
                                    return x.split(" ").filter((function (x) {
                                                  return x !== "";
                                                }));
                                  }), x.split("    "));
                    }), text.split("\n")).filter((function (x) {
                    return Caml_obj.caml_notequal(x, [[]]);
                  })));
}

function parseRow(row) {
  if (row.length > 3) {
    return Codons$Genetics.string_to_effect(Caml_array.caml_array_get(row, 3));
  } else {
    return Codons$Genetics.string_to_effect(Caml_array.caml_array_get(row, 1));
  }
}

function parse3CodeToTable(text) {
  return $$Array.map((function (row) {
                return {
                        code1: Caml_array.caml_array_get(row, 1),
                        code3: Caml_array.caml_array_get(row, 2),
                        does: parseRow(row),
                        codon: $$Array.to_list(Caml_array.caml_array_get(row, 0).replace(/\T/g, "U").split(""))
                      };
              }), text);
}

function processRaw3Code(text) {
  return parse3CodeToTable(formatRaw3Code(text));
}

function load(param) {
  return fetch((require("../Codons.tsv").default)).then((function (prim) {
                  return prim.text();
                })).then((function (text) {
                return Promise.resolve(parse3CodeToTable(formatRaw3Code(text)));
              }));
}

exports.formatRaw3Code = formatRaw3Code;
exports.parseRow = parseRow;
exports.parse3CodeToTable = parse3CodeToTable;
exports.processRaw3Code = processRaw3Code;
exports.load = load;
/* No side effect */
